import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import DockList from "./components/masters/dockmaster/dockmasterlist";
import Dock from "./components/dock/docklist";
import VehicleList from "./components/masters/vehicletype/vehiclelist";
import DockAdd from "./components/masters/dockmaster/dockadd";
import VehicleAdd from "./components/masters/vehicletype/vehicleadd";
import ViewDock from "./components/dock/dockview";
import AddDock from "./components/dock/dockadd";
import Docks from "./components/report/customizedreports";
import QuickReport from "./components/report/QuickReport";
import DockMarketView from "./components/masters/dockmaster/dockmasterview.js";
import AlertconfigurationAdd from "./components/masters/alertconfiguration/alertconfigurationadd.js";
import Alertconfiguration from "./components/masters/alertconfiguration/alertconfigurationlist.js";
import Registerfields from "./components/masters/registerfields/registerfieldslist.js";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

import "./components/Navbar/NavStyle.css";
import DashDock from "./components/Dashboard/Docks";
import Dashboard from "./components/Dashboard/Dashboard";
import Navbars from "./components/Navbar/Navbar";
import Default from "./components/Dashboard/Default";
import "./components/Dashboard/Dashboard.css";
import HelpQuestions from "./components/common/help";
import React, { createContext, useEffect, useState, useRef } from "react";
import { useGlobal } from "./GlobalContext";
import { apiCallAdmin } from "./services/api-service.js";
import PreLanding from "./pre-landing";
import UnAuthorized from "./components/common/unauthorized";
import CustomerPage from "./components/masters/customers/customerlist";
import TransporterPage from "./components/masters/transporter/transporterlist.js";
import ProductType from "./components/masters/producttype/producttype.js";
import VendorPage from "./components/masters/vendors/vendorlist.js";
import AutoTriggerPage from "./components/masters/autotrigger/autotriggerList.js";
import DockMasterView from "./components/masters/dockmaster/dockmasterview.js";
import RegisterFieldAdd from "./components/masters/registerfields/registerfieldadd.js";
import FuturisticDashboard from "./components/Dashboard/futuristic/FuturisticDashboard";

import GalleryList from "./components/gallery/gallery-list.js";
function App() {
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;

  const location = useLocation();
  // List of paths where header should be hidden
  const hideHeaderPaths = ["/"];

  const shouldHideHeader = hideHeaderPaths.includes(location.pathname);
  const { rolePermissionList, setRolePermissionList, userType, setUserType } = useGlobal();

  useEffect(() => {
    const channel = new BroadcastChannel(`auth_channel_mawalog_${environment}`);

    channel.onmessage = () => {
      window.location.reload();
    };

    return () => channel.close();
  }, []);

  useEffect(() => {
    getRolePermission();
  }, []);

  const getRolePermission = async () => {
    const response = await apiCallAdmin("GET", "get_role_permission/9", null, {
      params: {},
    });

    if (response?.status === 200) {
      if (response.data?.success === true) {
        setUserType(response.data.user_type);
        setRolePermissionList(response.data.role_permission ?? []);
        localStorage.setItem(
          "rolePermissionList",
          JSON.stringify(response.data.role_permission ?? [])
        );
        localStorage.setItem("userType", response.data.user_type ?? "");
      } else {
        setRolePermissionList([]);
      }
      return;
    }

    if (response?.status === 401) {
      document.cookie =
        "redirectPath=" + window.location.href + "; path=/; domain=.mawalog.com";
      document.cookie = "mawalog=; path=/; domain=.mawalog.com";
      window.location.href = accountsUrl;
      return;
    }

    console.error("Error fetching role permission:", response);
  };
  useEffect(() => {
    const checkToken = async () => {
      console.log("🔍 Checking token validity...");

      const response = await apiCallAdmin("GET", "validatetoken");

      console.log("✅ Token status:", response?.status);

      if (!response || response.status !== 200) {
        console.error("❌ Token validation failed:", response);
        handleInvalidToken();
      }
    };

    const handleInvalidToken = () => {
      const currentURL = window.location.href;

      const redirectData = {
        redirectPath: currentURL,
        app: "dock",
        ts: Date.now(),
      };

      console.warn("🔐 Saving redirect in window.name:", redirectData);

      // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
      window.name = JSON.stringify(redirectData);

      console.log("📌 window.name set:", window.name);

      // Clear token
      document.cookie = "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      console.log("➡️ Redirecting to login:", `${accountsUrl}/login`);
      window.location.href = `${accountsUrl}/login`;
    };

    // 🔥 IMPORTANT: run once on load
    console.log("🚀 Initial token check");
    checkToken();

    // Recheck when tab regains focus
    const onFocus = () => {
      console.log("👁 Window focused → rechecking token");
      checkToken();
    };

    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);
  }, []);
  if (rolePermissionList.length === 0 && location.pathname !== "/") {
    return <UnAuthorized />;
  }

  return (
    <>
      {!shouldHideHeader && <Navbars />}
      <Routes>
        <Route path="/" element={<PreLanding />} />
        {/*  <Route path="/" element={<Navigate to="/dashboard/default" />} /> */}
        <Route path="/futuristic" element={<FuturisticDashboard />} />
        <Route path="/dashdock" element={<DashDock />} />
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="default" element={<Default />} />
        </Route>

        <Route path="/dockmaster" element={userType === "SA" || userType === "A" ? <DockList /> : <UnAuthorized />} />
        <Route path="/vehicletype" element={userType === "SA" || userType === "A" ? <VehicleList /> : <UnAuthorized />} />
        <Route path="/dockadd" element={userType === "SA" || userType === "A" ? <DockAdd /> : <UnAuthorized />} />
        <Route path="/vehicleadd" element={userType === "SA" || userType === "A" ? <VehicleAdd /> : <UnAuthorized />} />
        <Route path="/customer" element={userType === "SA" || userType === "A" ? <CustomerPage /> : <UnAuthorized />} />
        <Route path="/transporter" element={userType === "SA" || userType === "A" ? <TransporterPage /> : <UnAuthorized />} />
        <Route path="/vendor" element={userType === "SA" || userType === "A" ? <VendorPage /> : <UnAuthorized />} />
        <Route path="/product" element={userType === "SA" || userType === "A" ? <ProductType /> : <UnAuthorized />} />
        <Route path="/autotrigger" element={userType === "SA" || userType === "A" ? <AutoTriggerPage /> : <UnAuthorized />} />
        <Route path="/alertconfigurations/add" element={userType === "SA" || userType === "A" ? <AlertconfigurationAdd /> : <UnAuthorized />} />
        <Route path="/alertconfigurations" element={userType === "SA" || userType === "A" ? <Alertconfiguration /> : <UnAuthorized />} />
        <Route path="/dock" element={<Dock />} />
        <Route path="/viewdock" element={<ViewDock />} />
        <Route path="/adddock" element={<AddDock />} />
        <Route path="/dock/view" element={<DockMasterView />} />
        <Route path="/registerfields" element={<Registerfields />} />
        <Route path="/registerfields/add" element={<RegisterFieldAdd />} />
        <Route path="/gallery" element={<GalleryList />} />

        <Route path="/customized" element={<Docks />} />
        <Route path="/quick-report" element={<QuickReport />} />
        <Route path="/help" element={<HelpQuestions />}></Route>
      </Routes>
    </>
  );
}

export default App;
